module.exports = __webpack_public_path__ + "img/button-text-deleted-on.7a2d0b3.svg";